import { QrCode, Sparkles, CheckCircle2, ShieldCheck, HeartHandshake, Zap, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-16">
      {/* Hero Header */}
      <div className="text-center max-w-3xl mx-auto space-y-4">
        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-mono font-semibold">
          <Sparkles className="w-3.5 h-3.5" /> Our Story & Mission
        </div>
        <h1 className="font-heading text-4xl sm:text-6xl font-bold text-slate-900 leading-tight">
          Reinventing Dining Experience With One Simple Scan
        </h1>
        <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
          Tablezy was founded to help cafes and restaurants replace bulky, outdated paper menus with sleek, instant, and touchless QR digital menus.
        </p>
      </div>

      {/* Core Principles Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="bg-card border border-border rounded-3xl p-8 space-y-3 shadow-sm hover:shadow-md transition-shadow">
          <div className="w-12 h-12 rounded-2xl bg-primary/10 text-primary grid place-items-center mb-2">
            <Zap className="w-6 h-6" />
          </div>
          <h3 className="font-heading text-2xl font-bold text-slate-900">Instant Speed</h3>
          <p className="text-slate-600 text-sm leading-relaxed">
            No app downloads or registration needed. Diners point their smartphone camera at the table QR code and the menu opens instantly in seconds.
          </p>
        </div>

        <div className="bg-card border border-border rounded-3xl p-8 space-y-3 shadow-sm hover:shadow-md transition-shadow">
          <div className="w-12 h-12 rounded-2xl bg-emerald-500/10 text-emerald-600 grid place-items-center mb-2">
            <HeartHandshake className="w-6 h-6" />
          </div>
          <h3 className="font-heading text-2xl font-bold text-slate-900">Merchant Empowerment</h3>
          <p className="text-slate-600 text-sm leading-relaxed">
            Restaurant owners gain full control over their menus — updating prices, adding seasonal specials, and toggling sold-out items without reprinting paper.
          </p>
        </div>

        <div className="bg-card border border-border rounded-3xl p-8 space-y-3 shadow-sm hover:shadow-md transition-shadow">
          <div className="w-12 h-12 rounded-2xl bg-blue-500/10 text-blue-600 grid place-items-center mb-2">
            <ShieldCheck className="w-6 h-6" />
          </div>
          <h3 className="font-heading text-2xl font-bold text-slate-900">Touchless & Hygienic</h3>
          <p className="text-slate-600 text-sm leading-relaxed">
            Provide your guests with a clean, modern, touchless dining experience that eliminates shared physical menu cards.
          </p>
        </div>
      </div>

      {/* Mission Banner */}
      <div className="bg-slate-900 text-white rounded-3xl p-10 sm:p-16 border border-slate-800 flex flex-col md:flex-row items-center justify-between gap-8 shadow-2xl">
        <div className="space-y-4 max-w-xl">
          <span className="text-xs font-mono uppercase tracking-widest text-primary font-bold">Empowering Restaurants Across India</span>
          <h2 className="font-heading text-3xl sm:text-4xl font-bold">Ready to Transform Your Cafe Menu?</h2>
          <p className="text-slate-300 text-sm sm:text-base">
            Join 50+ leading cafes, lounges, and bistros using Tablezy QR menus today.
          </p>
        </div>

        <Link
          to="/contact"
          className="h-14 px-8 rounded-full bg-primary text-white text-base font-semibold flex items-center justify-center gap-2 hover:bg-primary/90 transition-all shrink-0 shadow-lg shadow-primary/30"
        >
          <span>Get Your QR Menu</span>
          <ArrowRight className="w-5 h-5" />
        </Link>
      </div>
    </div>
  );
}
